import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import cardAgencyLogo from "../../assets/images/cardAgencyLogo.png";
import cardBusLogo from "../../assets/images/cardBusLogo.png";
import cardChargerLogo from "../../assets/images/cardChargerLogo.png";
import DashboardBarChart from "../../components/charts/DashboardBarChart";
import { Button } from "primereact/button";
import "./DashboardPage.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getBusesDataWrtEnergy,
  getChargersDataWrtPower,
  getDashboardNumbers,
} from "../../services/dashboard.service";
import { getPreviousTimePeriod } from "../../helpers/utils";
import moment from "moment";
import { getAgenciesWOL } from "../../services/agency.service";
import { agenciesSuccess } from "../../redux/agencies.slice";
import { switchUser } from "../../services/auth.service";
import {
  changeDashboardNumberTimeInterval,
  changeUserSuccess,
  changeDashboardgraphTimeInterval,
  changePreviousAdminId,
} from "../../redux/userSlice";
import useToast from "../../context/toast.hook";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import { BUS_TECHNOLOGY } from "../../constants/constant.data";
import { getCurrentUser } from "../../services/user.service";
import { useNavigate } from "react-router-dom";

const DashboardPage = () => {
  const [graphLoading, setGraphLoading] = useState(false);
  const navigate = useNavigate();
  const [selectedTechnology, setSelectedTechnology] = useState(
    BUS_TECHNOLOGY[0]
  );
  const { errorToast, toastRef } = useToast();
  const dispatch = useDispatch();
  const currentDate = moment().format("YYYY-MM-DD");
  const previousDate = moment().subtract(1, "months").format("YYYY-MM-DD");
  const {
    currentUser,
    isAdmin,
    dashboardNumberTimeInterval,
    dashboardGraphTimeInterval,
    previousAdminId,
  } = useSelector((state) => state.user);

  const { allAgencies } = useSelector((state) => state.agencies);
  const [dashboardNumbers, setDashboardNumbers] = useState(null);
  const [numbersLoading, setNumbersLoading] = useState({
    agencies: false,
    buses: false,
    chargers: false,
  });

  const [dateFilter, setDateFilter] = useState({
    buses: {
      fromDate: previousDate,
      toDate: currentDate,
    },
    chargers: {
      fromDate: previousDate,
      toDate: currentDate,
    },
    agencies: {
      fromDate: previousDate,
      toDate: currentDate,
    },
  });
  const [busEnergyData, setBusEnergyData] = useState([]);
  const [avgFailureDistanceData, setavgFailureDistanceData] = useState([]);
  const [chargerPowerData, setChargerPowerData] = useState([]);

  const graphdatesList = [
    { name: "1 Month", code: "month" },
    { name: "6 Months", code: "half_year" },
    { name: "1 Year", code: "year" },
  ];

  const handleGetDashboardNumbers = (tempDateFilter) => {
    getDashboardNumbers(tempDateFilter || dateFilter)
      .then((res) => {
        setDashboardNumbers(res?.data?.data);
        setNumbersLoading({ agencies: false, buses: false, chargers: false });
      })
      .catch((error) => {
        errorToast(error);
        setNumbersLoading({ agencies: false, buses: false, chargers: false });
      });
  };

  const getAllAgencies = () => {
    if (currentUser?.role === "admin") {
      getAgenciesWOL()
        .then((res) => {
          dispatch(agenciesSuccess(res?.data?.data));
        })
        .catch((error) => {
          errorToast(error);
        });
    }
  };

  const getChargerPowerStats = (currentTechnology, dateCode) => {
    const result = getPreviousTimePeriod(
      dateCode || dashboardGraphTimeInterval?.code
    );

    getChargersDataWrtPower({
      ...result,
      technology: currentTechnology?.key || selectedTechnology?.key,
    })
      .then((res) => {
        setChargerPowerData(res?.data?.data);
      })
      .catch((error) => {
        errorToast(error);
      });
  };
  const getBusEnergyStats = (currentTechnology, dateCode) => {
    const result = getPreviousTimePeriod(
      dateCode || dashboardGraphTimeInterval?.code
    );
    setGraphLoading(true);
    getBusesDataWrtEnergy({
      ...result,
      technology: currentTechnology?.key || selectedTechnology?.key,
    })
      .then((res) => {
        setBusEnergyData(res?.data?.data);
        setavgFailureDistanceData(res?.data?.avgFailureDistance);
        setGraphLoading(false);
      })
      .catch((error) => {
        errorToast(error);
      });
  };

  const handleGetCurrentUser = async () => {
    try {
      const result = await getCurrentUser(currentUser?.id);
      dispatch(changeUserSuccess(result?.data?.user));
      handleChangeDate(dashboardNumberTimeInterval);
      getAllAgencies();
      getBusEnergyStats();
      getChargerPowerStats();
    } catch (error) {
      errorToast(error);
      navigate("/login");
    }
  };

  useEffect(() => {
    handleGetCurrentUser();
  }, []);

  const handleChangeDate = (value) => {
    const period = value?.code || value;
    const result = getPreviousTimePeriod(period);
    const tempDateFilter = {
      ...dateFilter,
      agencies: result,
      buses: result,
      chargers: result,
    };
    setDateFilter(tempDateFilter);

    setNumbersLoading({
      ...numbersLoading,
      agencies: true,
      buses: true,
      chargers: true,
    });
    dispatch(changeDashboardNumberTimeInterval(value));
    handleGetDashboardNumbers(tempDateFilter);
  };

  const handleSwitchUser = (userId, previousAdmin) => {
    switchUser(userId)
      .then((res) => {
        dispatch(
          changeUserSuccess({
            ...res?.data?.user,
          })
        );
        if (!previousAdmin) {
          dispatch(
            changePreviousAdminId({ previousAdminId: currentUser?._id })
          );
        }
        localStorage.setItem("authToken", res.data.token);
        handleChangeDate(dashboardNumberTimeInterval);
        getBusEnergyStats();
        getChargerPowerStats();
      })
      .catch((error) => {
        errorToast(error);
      });
  };

  const handleChangeGraphDate = (value) => {
    dispatch(changeDashboardgraphTimeInterval(value));
    getChargerPowerStats(false, value?.code);
    getBusEnergyStats(false, value?.code);
  };

  const handleChangeTechnology = (value) => {
    setSelectedTechnology(value);
    getChargerPowerStats(value);
    getBusEnergyStats(value);
  };

  const handleH2Label = (key, isTooltip) => {
    if (key === "average") {
      return selectedTechnology?.dashboardUnit === "(kg H2/100 km)" &&
        !isTooltip ? (
        <span>
          Average {selectedTechnology?.dataLabel} Usage (kg H<sub>2</sub>/100
          km)
        </span>
      ) : (
        `Average ${selectedTechnology?.dataLabel} Usage ${selectedTechnology?.dashboardUnit}`
      );
    }

    if (key === "consumed") {
      return selectedTechnology?.dashboardUnit === "(kg H2/100 km)" &&
        !isTooltip ? (
        <span>
          {selectedTechnology?.dataLabel} Consumed per Vehicle (kg H<sub>2</sub>
          /100 km)
        </span>
      ) : (
        `${selectedTechnology?.dataLabel} Consumed per Vehicle ${selectedTechnology?.dashboardUnit}`
      );
    }
  };

  return (
    <>
      <Toast ref={toastRef} />
      <div className="initialBox">
        {currentUser?.role === "admin" || isAdmin ? (
          <>
            {" "}
            <div className="welcomeBox">
              <div className="imgBoxWelcome">
                <strong>
                  Welcome{" "}
                  <span className="diffText">
                    {currentUser?.name || "User"}!
                  </span>
                </strong>
              </div>
            </div>
            {currentUser?.role === "admin" && isAdmin ? (
              <>
                <Dropdown
                  id="customDropdownId"
                  style={{
                    backgroundColor: "#1C9894",
                    color: "white",
                    maxHeight: "45px",
                    zIndex: "0",
                  }}
                  optionLabel="name"
                  options={allAgencies}
                  onChange={(e) => {
                    handleSwitchUser(e?.value?._id);
                  }}
                  className="custom-placeholder-color"
                  placeholder="Switch to Agency"
                />
              </>
            ) : (
              <>
                <Button
                  className="switchAdmin"
                  label="Switch to Admin"
                  style={{ width: "170px", border: "0", height: "45px" }}
                  onClick={() => {
                    handleSwitchUser(previousAdminId, "admin");
                  }}
                />
              </>
            )}
          </>
        ) : (
          <>
            <div className="welcomeBox">
              <strong>
                Welcome{" "}
                <span className="diffText">{currentUser?.name || "User"}!</span>
              </strong>
            </div>
          </>
        )}
      </div>

      <div className="layout-main">
        <div className="dateBox">
          <Dropdown
            value={dashboardNumberTimeInterval}
            id="customDropdownId"
            style={{
              backgroundColor: "#1C9894",
              color: "white",
              maxHeight: "45px",
              zIndex: "0",
            }}
            optionLabel="name"
            placeholder="Time Frame"
            options={graphdatesList}
            onChange={(e) => {
              handleChangeDate(e.value);
            }}
          />

          {/* <select
            name=""
            id="selectBus"
            className="selectBus"
            placeholder="Buses"
            style={{ width: "130px", height: "40px" }}
            onChange={(e) => {
              handleChangeDate(e.target.value);
            }}
            value={dashboardNumberTimeInterval}
          >
            <option value="" disabled selected hidden>
              Select date
            </option>
            <option value="month">1 month</option>
            <option value="half_year">6 months</option>
            <option value="year">1 year</option>
          </select> */}
        </div>
        <div className="grid mt-2 sm:flex-column md:flex-row">
          {currentUser?.role === "admin" && (
            <div className="col">
              <div className="dashboardCard">
                <div className="flex justify-content-between mb-3">
                  <div>
                    <strong>
                      {" "}
                      <span className="cardSpan">
                        Number of Participating Agencies
                      </span>
                    </strong>
                  </div>
                </div>
                <div className="flex justify-content-between mb-3">
                  <img src={cardAgencyLogo} alt="Agency"></img>

                  <strong>
                    {" "}
                    <span className="cardText">
                      {numbersLoading && numbersLoading?.agencies ? (
                        <ProgressSpinner
                          style={{ height: "50px", width: "50px" }}
                        />
                      ) : (
                        dashboardNumbers?.agencies || 0
                      )}
                    </span>
                  </strong>
                </div>
              </div>
            </div>
          )}

          <div className="col">
            <div className="dashboardCardBus">
              <div className="flex justify-content-between mb-3">
                <div>
                  <strong>
                    {" "}
                    <span className="cardSpan">Buses in Service</span>
                  </strong>
                </div>
              </div>
              <div className="busClassCard">
                <div className="flexClass">
                  <img src={cardBusLogo} className="busLogo" alt="Bus"></img>
                </div>

                <div className="flexClass1">
                  <strong>
                    {" "}
                    <span className="cardText">
                      {numbersLoading && numbersLoading?.buses ? (
                        <ProgressSpinner
                          style={{ height: "50px", width: "50px" }}
                        />
                      ) : (
                        dashboardNumbers?.buses || 0
                      )}
                    </span>
                  </strong>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="dashboardCardCharger">
              <div className="flex justify-content-between mb-3">
                <div>
                  <strong>
                    {" "}
                    <span className="cardSpan">Chargers in Service</span>
                  </strong>
                </div>
              </div>
              <div className="flex justify-content-between mb-3">
                <img src={cardChargerLogo} alt="Charger"></img>

                <strong>
                  {" "}
                  <span className="cardText">
                    {" "}
                    {numbersLoading && numbersLoading?.chargers ? (
                      <ProgressSpinner
                        style={{ height: "50px", width: "50px" }}
                      />
                    ) : (
                      dashboardNumbers?.chargers || 0
                    )}
                  </span>
                </strong>
              </div>
            </div>
          </div>
        </div>{" "}
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            zIndex: 0,
            gap: "10px",
          }}
        >
          <Dropdown
            value={selectedTechnology}
            id="customDropdownId"
            style={{
              backgroundColor: "#1C9894",
              color: "white",
              maxHeight: "45px",
              zIndex: "0",
            }}
            optionLabel="key"
            filter
            options={BUS_TECHNOLOGY}
            placeholder="Propulsion"
            onChange={(e) => handleChangeTechnology(e.value)}
          />
          <Dropdown
            value={dashboardGraphTimeInterval}
            id="customDropdownId"
            style={{
              backgroundColor: "#1C9894",
              color: "white",
              maxHeight: "45px",
              zIndex: "0",
            }}
            optionLabel="name"
            placeholder="Time Frame"
            options={graphdatesList}
            onChange={(e) => handleChangeGraphDate(e.value)}
          />
        </div>
        {graphLoading ? (
          <div className="dashboard-spinner-wrapper">
            {" "}
            <ProgressSpinner />
          </div>
        ) : (
          <div>
            <DashboardBarChart
              graphData={busEnergyData}
              title="Distance Travelled per Vehicle (km)"
              unit="(km)"
              xField={currentUser?.role === "admin" ? "agencyName" : "busName"}
              yField="distanceTravelled"
              tooltipText="Distance Travelled per Vehicle (km)"
            />
            <DashboardBarChart
              graphData={busEnergyData}
              title={
                Object.keys(selectedTechnology)?.length
                  ? handleH2Label("consumed")
                  : "kgh2"
              }
              unit={selectedTechnology?.dataUnit || " kWh"}
              xField={currentUser?.role === "admin" ? "agencyName" : "busName"}
              yField="energy"
              tooltipText={
                Object.keys(selectedTechnology)?.length
                  ? handleH2Label("consumed", "tooltip")
                  : "kgh2"
              }
            />
            <DashboardBarChart
              graphData={busEnergyData}
              title={
                Object.keys(selectedTechnology)?.length
                  ? handleH2Label("average")
                  : "Average Energy Fuel Consumption Rate (km)"
              }
              unit={selectedTechnology?.dataUnit || "kWh/km"}
              xField={currentUser?.role === "admin" ? "agencyName" : "busName"}
              yField="efficiency"
              tooltipText={
                Object.keys(selectedTechnology)?.length
                  ? handleH2Label("average", "toolti[")
                  : "Average Energy Fuel Consumption Rate (km)"
              }
            />
            <DashboardBarChart
              graphData={busEnergyData}
              title={
                Object.keys(selectedTechnology)?.length
                  ? `Relative ${selectedTechnology?.dataLabel} Cost (C$/km)`
                  : "Relative Energy Cost (C$/km)"
              }
              unit="(C$/km)"
              xField={currentUser?.role === "admin" ? "agencyName" : "busName"}
              yField="energyCost"
              tooltipText={
                Object.keys(selectedTechnology)?.length
                  ? `Relative ${selectedTechnology?.dataLabel} Cost (C$/km)`
                  : "Relative Energy Cost (C$/km)"
              }
            />
            {/* TODO: Temporarily hide MDBF (KPI) on the Dashboard due to ongoing methodological discussions. Visibility will be restored upon reaching a consensus. */}
            {/* {avgFailureDistanceData &&
          Object.keys(avgFailureDistanceData)?.length > 0 && (
            <DashboardBarChart
              graphData={avgFailureDistanceData}
              title="Average distance between failures (km)"
              unit="(km)"
              xField={"date"}
              yField="mean_dist_betw_fails"
              tooltipText="Average distance between failures (km)"
            />
          )} */}
            {selectedTechnology &&
            Object.keys(selectedTechnology)?.length &&
            ["BEB", "FC"].includes(selectedTechnology?.key) ? (
              <>
                <DashboardBarChart
                  graphData={chargerPowerData}
                  title="Charger Power Data (kW)"
                  unit="(kW)"
                  xField={
                    currentUser?.role === "admin" ? "agencyName" : "chargerName"
                  }
                  yField="power"
                  tooltipText="Charger Power Data (kW)"
                />

                <DashboardBarChart
                  graphData={busEnergyData}
                  title="Cost per km (C$)"
                  unit="(C$)"
                  xField={
                    currentUser?.role === "admin" ? "agencyName" : "busName"
                  }
                  yField="centsPerKm"
                  tooltipText="Cost per km (C$)"
                />
              </>
            ) : (
              ""
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default DashboardPage;
